module.exports = __webpack_public_path__ + "img/user-wallet.27898766.svg";